<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Pedidos gerados no ERP Winthor"
    ocultar-acoes
    :largura="500"
  >
    <template #ativador>
      <v-btn icon title="Visualizar resultado da exportação para o ERP Winthor" @click="dialog_ativo = true">
        <v-icon>mdi-file-eye</v-icon>
      </v-btn>
    </template>

    <ul class="mt-n2 pb-2">
      <li v-for="ordem in RESULTADO_EXPORTACAO_COMPUTED.orders" class="font-14">
        {{ ordem.numeroPedido }}
      </li>
    </ul>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {computed, ref} from "vue";

const props = defineProps({
  pedido: {
    type: Object,
    required: true
  }
});

const RESULTADO_EXPORTACAO_COMPUTED = computed(() => JSON.parse(props.pedido.exportacao_winthor))

const dialog_ativo = ref(false);
</script>

<style scoped>

</style>
